var _defs, _rect, _rect2, _rect3, _rect4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgNoimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 460,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 374.999991",
    height: 275,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#f8f3f3",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#f8f3f3",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.624991, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.296875 -23.4375 L 7.296875 0 L 3.65625 0 L 3.65625 -28.390625 L 8.765625 -28.390625 L 21.28125 -4.78125 L 21.28125 -28.390625 L 24.9375 -28.390625 L 24.9375 0 L 19.90625 0 Z M 7.296875 -23.4375 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.202271, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.03125 -14.234375 C 2.03125 -16.316406 2.332031 -18.25 2.9375 -20.03125 C 3.550781 -21.8125 4.429688 -23.359375 5.578125 -24.671875 C 6.722656 -25.984375 8.117188 -27.007812 9.765625 -27.75 C 11.421875 -28.5 13.300781 -28.875 15.40625 -28.875 C 17.488281 -28.875 19.359375 -28.488281 21.015625 -27.71875 C 22.679688 -26.945312 24.085938 -25.894531 25.234375 -24.5625 C 26.390625 -23.238281 27.273438 -21.691406 27.890625 -19.921875 C 28.515625 -18.148438 28.828125 -16.253906 28.828125 -14.234375 C 28.828125 -12.203125 28.519531 -10.296875 27.90625 -8.515625 C 27.300781 -6.734375 26.414062 -5.171875 25.25 -3.828125 C 24.09375 -2.492188 22.691406 -1.441406 21.046875 -0.671875 C 19.398438 0.0976562 17.519531 0.484375 15.40625 0.484375 C 13.300781 0.484375 11.421875 0.0976562 9.765625 -0.671875 C 8.117188 -1.441406 6.722656 -2.492188 5.578125 -3.828125 C 4.429688 -5.171875 3.550781 -6.734375 2.9375 -8.515625 C 2.332031 -10.296875 2.03125 -12.203125 2.03125 -14.234375 Z M 5.953125 -14.234375 C 5.953125 -12.773438 6.160156 -11.351562 6.578125 -9.96875 C 7.003906 -8.59375 7.625 -7.378906 8.4375 -6.328125 C 9.25 -5.273438 10.238281 -4.429688 11.40625 -3.796875 C 12.582031 -3.160156 13.914062 -2.84375 15.40625 -2.84375 C 16.976562 -2.84375 18.347656 -3.128906 19.515625 -3.703125 C 20.691406 -4.285156 21.675781 -5.082031 22.46875 -6.09375 C 23.269531 -7.113281 23.875 -8.316406 24.28125 -9.703125 C 24.6875 -11.097656 24.890625 -12.609375 24.890625 -14.234375 C 24.890625 -15.691406 24.671875 -17.09375 24.234375 -18.4375 C 23.804688 -19.789062 23.1875 -20.992188 22.375 -22.046875 C 21.570312 -23.109375 20.582031 -23.957031 19.40625 -24.59375 C 18.226562 -25.226562 16.894531 -25.546875 15.40625 -25.546875 C 13.914062 -25.546875 12.582031 -25.253906 11.40625 -24.671875 C 10.238281 -24.085938 9.25 -23.289062 8.4375 -22.28125 C 7.625 -21.269531 7.003906 -20.070312 6.578125 -18.6875 C 6.160156 -17.3125 5.953125 -15.828125 5.953125 -14.234375 Z M 5.953125 -14.234375 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.049521, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.210069, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.65625 0 L 3.65625 -28.390625 L 7.5 -28.390625 L 7.5 0 Z M 3.65625 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.357232, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 26.3125 -23.484375 L 18.734375 -6.40625 L 14.921875 -6.40625 L 7.296875 -23.484375 L 7.296875 0 L 3.65625 0 L 3.65625 -28.390625 L 9.046875 -28.390625 L 16.90625 -10.421875 L 24.65625 -28.390625 L 30.171875 -28.390625 L 30.171875 0 L 26.3125 0 Z M 26.3125 -23.484375 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(395.163546, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.40625 -1.015625 L 11.515625 -28.390625 L 15.734375 -28.390625 L 26.6875 -1.015625 L 23.15625 0.40625 L 19.984375 -7.703125 L 6.859375 -7.703125 L 3.6875 0.328125 Z M 8.0625 -10.953125 L 18.734375 -10.953125 L 13.421875 -24.578125 Z M 8.0625 -10.953125 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.241021, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.171875 -15.046875 L 24.6875 -15.046875 L 24.6875 0 L 21.28125 0 L 21.28125 -2.84375 C 20.34375 -2 19.195312 -1.234375 17.84375 -0.546875 C 16.488281 0.140625 14.988281 0.484375 13.34375 0.484375 C 11.6875 0.484375 10.171875 0.160156 8.796875 -0.484375 C 7.421875 -1.128906 6.234375 -2.0625 5.234375 -3.28125 C 4.234375 -4.5 3.445312 -5.96875 2.875 -7.6875 C 2.3125 -9.40625 2.03125 -11.332031 2.03125 -13.46875 C 2.03125 -15.738281 2.316406 -17.8125 2.890625 -19.6875 C 3.472656 -21.5625 4.316406 -23.179688 5.421875 -24.546875 C 6.535156 -25.910156 7.894531 -26.972656 9.5 -27.734375 C 11.113281 -28.492188 12.945312 -28.875 15 -28.875 C 16.78125 -28.875 18.351562 -28.65625 19.71875 -28.21875 C 21.09375 -27.789062 22.382812 -27.238281 23.59375 -26.5625 L 22.171875 -23.359375 C 21.035156 -23.972656 19.882812 -24.484375 18.71875 -24.890625 C 17.5625 -25.296875 16.253906 -25.5 14.796875 -25.5 C 13.523438 -25.5 12.347656 -25.242188 11.265625 -24.734375 C 10.191406 -24.222656 9.257812 -23.46875 8.46875 -22.46875 C 7.6875 -21.46875 7.070312 -20.226562 6.625 -18.75 C 6.175781 -17.28125 5.953125 -15.597656 5.953125 -13.703125 C 5.953125 -12.003906 6.15625 -10.484375 6.5625 -9.140625 C 6.96875 -7.804688 7.535156 -6.671875 8.265625 -5.734375 C 8.992188 -4.804688 9.863281 -4.097656 10.875 -3.609375 C 11.894531 -3.117188 13.015625 -2.875 14.234375 -2.875 C 14.992188 -2.875 15.707031 -2.960938 16.375 -3.140625 C 17.050781 -3.316406 17.671875 -3.546875 18.234375 -3.828125 C 18.804688 -4.109375 19.328125 -4.414062 19.796875 -4.75 C 20.273438 -5.09375 20.691406 -5.441406 21.046875 -5.796875 L 21.046875 -12 L 15.171875 -12 Z M 15.171875 -15.046875 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(449.561717, 197.099973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.65625 -28.390625 L 20.671875 -28.390625 L 20.671875 -25.0625 L 7.5 -25.0625 L 7.5 -16.421875 L 18.859375 -16.421875 L 18.859375 -13.171875 L 7.5 -13.171875 L 7.5 -3.328125 L 20.671875 -3.328125 L 20.671875 0 L 3.65625 0 Z M 3.65625 -28.390625 "
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimg);
export default __webpack_public_path__ + "static/media/noimg.8b5a2fda.svg";
export { ForwardRef as ReactComponent };